<script>
//import catalog from '@/mixins/catalog';
const ListingCard = () => import ('@/components/listing-card');

export default {

  name: 'carousel',
  props: ['proxyData'],  
  components: {"listing-card":ListingCard},
  //mixins: [catalog],
  //template: '#location',
  data: function(){

      return {
        url:"/bitrix/services/main/ajax.php",
        smartFilterParams:[],
        category:0,
        search:"",
        loading: false,
        nextPage: false,
      }
  },  
  created () {

    window.addEventListener('scroll', this.onScroll);

    //console.log(this.proxyData.arResult);
    //
    

    
        

    //var $window  = $(window);

    },

    destroyed () {

    window.removeEventListener('scroll', this.onScroll);

    },

    mounted: function () {


    this.proxyData.arResult = JSON.parse(this.proxyData.arResult);


    this.$set(this.proxyData.arResult, "NAV", {CURRENT_PAGE: 0, ALL:1});


    if(this.proxyData.arResult["ITEMS"])
    {
        this.prepareImages();
    }



    },
    methods:{

        onScroll(event){


            if(($(window).scrollTop() + $(window).height()) > ($(this.$el).offset().top + $(this.$el).height() + 100) && 
                    this.proxyData.arResult["NAV"].CURRENT_PAGE !== this.proxyData.arResult["NAV"].ALL &&
                    !this.loading) {
                
                this.loading = true;
                this.addPage();
            }



        },

        smartFilterUse: function(){



        },

        outControlImage: function(index, photo, item)
        {
        

        // this.$set(photo, 'active', false);
        },



        prepareImages: function(items){

            if(!items)
            {
                items = this.proxyData.arResult["ITEMS"];
            
            }


            let vue = this;

            items.forEach(function(param, i, arr){

                
                if(param.GALLERY !== null)
                {
                    
                    if(!param.GALLERY[0].hasOwnProperty('src'))
                    {
                        param.GALLERY[0].src = vue.proxyData.componentPath+"/images/shop.png";
                        param.GALLERY[0].width = 200;
                        param.GALLERY[0].height = 200;
                    }

                    // param.GALLERY.push({src: vue.proxyData.componentPath+"/images/shop.png", 
                    //                     width: 200,
                    //                     height: 200
                    //                 });
                }

                if(param.GALLERY)
                {
                    let width = 100 / param.GALLERY.length;
                    param.GALLERY.forEach(element => {
                        
                        element.width_control = width - 0.5;

                        //element.active = false;
                    });

                    param.GALLERY[0].active = true;
                }

                if(param.PREVIEW_PICTURE == null)
                {
                    param.PREVIEW_PICTURE = {};
                    param.PREVIEW_PICTURE.SRC = vue.proxyData.componentPath+"/images/shop.png";
                }
            });

            return items;

        },

        getOrder: function()
        {
            let code = false;

            if(this.proxyData.arResult.ORDER)
            {
                this.proxyData.arResult.ORDER.forEach(function(element, key){

                        if(element.SELECTED)
                        {

                            code = element["CODE"];
                        }
                });
            }

            
            return code;
        },

        setOrder: function(event)
        {   
            this.proxyData.arResult.ORDER.forEach(function(element, key){

                if(key == event.target.value)
                {
                    element.SELECTED = true;
                }
                else
                {
                    element.SELECTED = false;
                }
            });
            

            this.searchInput();
        },

        searchInput: function()
        {
            //event.preventDefault();
            //event.stopImmediatePropagation();
            this.refreshData();
        },

        addPage: function()
        {
            let vue = this;

            event.preventDefault();
            event.stopImmediatePropagation();

            this.nextPage = true;
            this.proxyData.arResult.NAV.CURRENT_PAGE = this.proxyData.arResult.NAV.CURRENT_PAGE+1;
            this.refreshData();
        
        },


        refreshData: function(){

            let vue = this;

            let data = {search: this.search, 
                        order: this.getOrder(),  
                        category: this.category, 
                        smartFilter:{}
                        }; // ключи объекта data соответствуют параметрам метода



            if(this.smartFilterParams)
            {
                for(param in this.smartFilterParams)
                {
                    data.smartFilter[param] = this.smartFilterParams[param];
                }

            }

            let params =  { // Вызывается без постфикса Action
                mode: 'class',
                //navigation: {page: this.proxyData.arResult.NAV.CURRENT_PAGE},
                data: data,
                signedParameters: this.proxyData.signedParameters
            };

            let number_page = "1";

            if(vue.nextPage)
            {
                params.navigation = {page: this.proxyData.arResult.NAV.CURRENT_PAGE};
                number_page = this.proxyData.arResult.NAV.CURRENT_PAGE;
            }

            let params_query = new URLSearchParams({
                    mode: "class",
                    nav: "page-"+number_page,
                    c: "vue:shops",
                    action:"filterShops"
            });

            data.signedParameters = this.proxyData.signedParameters;

            $.ajax({
                type: "POST",
                url: "/bitrix/services/main/ajax.php?"+params_query.toString(),
                data: data,
                headers: {'x-bitrix-csrf-token': this.proxyData.token,
                        'x-bitrix-site-id': this.siteId },
                //dataType: "dataType",
                success: function (response) {

                    if (response.status === 'success') {

                        if(!('ITEMS' in vue.proxyData.arResult))
                        {
                            vue.$set(vue.proxyData.arResult, "ITEMS", []);
                        }

                        if(vue.nextPage)
                        {
                            response.data.data = vue.prepareImages(response.data.data);

                            response.data.data.forEach(element => {

                                vue.proxyData.arResult.ITEMS.push(element);
                            });
                            
                            vue.nextPage = false;
                        }
                        else
                        {
                            vue.proxyData.arResult.ITEMS = [];
                            vue.proxyData.arResult.ITEMS = vue.prepareImages(response.data.data);
                        }

                        //console.log(vue.proxyData.arResult.ITEMS);
                        vue.proxyData.columnElements = Math.floor(vue.proxyData.arResult.ITEMS.length / 7);
                        if(vue.proxyData.columnElements > 4)
                        {
                            vue.proxyData.columnElements = 4;
                        }
                        
                        //vue.proxyData.arResult["NAV"] = response.data.nav;
                        vue.loading = false;

                    }
                    //console.log(response);
                }
            });
            

        },

        nextSwiper: function(){

            //console.log(this.$refs);
            this.$refs.swiper.swiper.slideNext();
        },

        prevSwiper: function()
        {
            this.$refs.swiper.swiper.slidePrev();
        }



    }

}



</script>

<style>
.carousel
{
    position:relative;
   
}
.nav-swiper
{
    position: absolute;
    top: -40px;
    right: 0px;
    display:flex;
    color:orange;
    cursor:pointer;
}

.nav-swiper>div {
    --swiper-navigation-color: orange;
}
.nav-swiper .left-arrow
{
    right: 45px;
    left:auto;
    margin-right: 10px;
}

.nav-swiper .right-arrow
{
    right:0;
    left:auto;
}

.carousel-container {
      width: 100%;

    }

    .product-element {
      text-align: center;
      font-size: 18px;
      background: #fff;
      /* height: calc((100% - 30px) / 2) !important; */
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .carousel .shops-bor-cart
    {
        width:100%;
        margin-top:45px;
    }

    .one-line .product-element
    {
        height: 460px !important;
    }

    .one-line .product-element .shops-bor-cart
    {
        margin-top:0;
    }

</style>

<template>
    <div>
        <div class="carousel" v-if="proxyData.arResult.ITEMS">
                
                <div class="nav-swiper" v-if="proxyData.arResult.ITEMS.length > 5">
                    <div class="left-arrow swiper-button-prev" @click="prevSwiper">
                        <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor" transform-origin="center" transform="rotate(180)"></path></svg>
                    </div>
                    <div class="right-arrow swiper-button-next" @click="nextSwiper">
                        <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor" transform-origin="center"></path></svg>
                    </div>
                </div>
                <swiper-container
                    :slides-per-view="5"
                    :pagination="false"
                    space-between="15"
                    ref="swiper"
                    :grid-rows="proxyData.columnElements"
                    class="carousel-container"
                    :style="{height: (420 * proxyData.columnElements + 40)+'px'}"
                    :class="{'one-line': proxyData.columnElements== 1 }"
                >
               
                <swiper-slide v-for="item in proxyData.arResult.ITEMS" :key="item.ID" class="product-element" :style="{height: 'calc((100% - 100px) /'+proxyData.columnElements+')'}">
                    <div class="shops-bor-cart" >
                        <listing-card :item="item"></listing-card>
                    </div>  
                </swiper-slide>
                        
            </swiper-container>   
           
        </div>
        <div class="row">
            <div class="col-xl-12">
                <div class="loader" v-show="loading">
                       <img :src="proxyData.siteTemplatePath+'/images/loader.gif'" alt=""> 
                </div>
            </div>
        </div>       
    </div>
             
</template>